<template>
  <div>
    <div
      class="nav-bar"
      :class="{
        'nav-bar--scrolled': isScrolled,
        'nav-bar--transparent': !isScrolled,
      }"
    >
      <!-- 官网导航 -->
      <div class="menu-row" v-if="!isMobile">
        <div class="menu-left">
          <router-link to="/" class="logo">
            <img class="brand-logo" :src="brandLogo" alt="" />
          </router-link>
          <!-- 导航链接 pill 容器 -->
          <div class="nav-pills">
            <router-link to="/" exact class="nav-pill" active-class="nav-pill--active">首页</router-link>
            <router-link
              to="/learning-center"
              :class="{
                'nav-pill--active': [
                  'myCourse',
                  'liveCalendar',
                  'myCourseDetail',
                ].includes($route.name),
              }"
              class="nav-pill learning-center group"
            >
              学习中心
              <div v-if="todayHaveLive && isAuthenticated" class="learning-center-badge">
                <span class="badge-dot-wrapper">
                  <span class="badge-dot-ping"></span>
                  <span class="badge-dot-core"></span>
                </span>
                今日有课
              </div>
            </router-link>
            <router-link
              class="nav-pill nav-pill--highlight"
              v-if="!(user && user.org_id)"
              to="/org-settled"
              exact
            >
              <span class="nav-pill__store-icon">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"/><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"/><path d="M2 7h20"/><path d="M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7"/></svg>
              </span>
              机构入驻
              <span class="nav-pill__badge">免费</span>
            </router-link>
            <a v-else :href="adminUrl" target="_blank" class="nav-pill">管理后台</a>
            <a
              href="/download"
              target="_blank"
              :class="{
                'nav-pill--active': $route.name === 'Download',
              }"
              class="nav-pill"
              >下载</a
            >
            <a href="https://help.moguoyunke.com/guide/" target="_blank" class="nav-pill"
              >帮助中心</a
            >
          </div>
        </div>
        <div class="menu-right">
          <!-- 搜索 -->
          <SearchInput />
          <!-- 主题切换 -->
          <button
            @click="toggleTheme"
            class="theme-toggle-btn"
            :title="isDark ? '切换亮色模式' : '切换暗夜模式'"
          >
            <svg v-if="isDark" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>
            <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
          </button>
          <!-- 消息铃铛 -->
          <button
            v-if="isAuthenticated"
            @click="$router.push('/msg-list')"
            class="msg-bell-btn"
            title="消息通知"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
          </button>
          <el-dropdown
            v-if="isAuthenticated"
            trigger="hover"
            @command="handleMenuBehavior"
            class="user-content"
          >
            <span class="el-dropdown-link user-avatar-btn">
              <img class="avatar" :src="user.avatar" alt="头像" />
              <span class="user-name">{{ user.nickname || user.username }}</span>
            </span>
            <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
              <el-dropdown-item v-if="!(user && user.org_id)" command="OrgSettled"
                >机构入驻</el-dropdown-item
              >
              <el-dropdown-item v-else command="admin"
                >管理后台</el-dropdown-item
              >
              <el-dropdown-item command="LearningCenter"
                >学习中心</el-dropdown-item
              >
              <el-dropdown-item command="CommentList"
                >课程评价</el-dropdown-item
              >
              <el-dropdown-item command="MyNote">我的笔记</el-dropdown-item>
              <el-dropdown-item command="UserInfo">个人信息</el-dropdown-item>
              <el-dropdown-item command="Exchange">课程兑换</el-dropdown-item>
              <el-dropdown-item command="Trade">我的订单</el-dropdown-item>
              <el-dropdown-item command="logout" class="logout-item">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="not-login" v-else>
            <button @click="login" class="login-btn">登录</button>
            <button @click="login" class="register-btn">
              免费注册
              <svg class="register-sparkle" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M12 0L14.59 8.41L23 12L14.59 15.59L12 24L9.41 15.59L1 12L9.41 8.41Z"/></svg>
            </button>
          </div>
        </div>
      </div>
      <!-- h5导航 -->
      <div v-else>
        <el-row class="h5-nav">
          <el-col :span="8">
            <div class="logo-name">
              <i class="el-icon-s-fold" @click="drawer = true"></i>
              <img class="brand-logo" :src="brandLogo" alt="" />
            </div>
          </el-col>
          <el-col :span="16" class="menu-right">
            <router-link to="/learning-center">学习中心</router-link>
            <router-link v-if="!(user && user.org_id)" to="/org-settled"
              >机构入驻</router-link
            >
            <a v-else :href="adminUrl" target="_blank">管理后台</a>
            <el-dropdown
              v-if="isAuthenticated"
              trigger="hover"
              @command="handleMenuBehavior"
              class="user-content"
            >
              <span class="el-dropdown-link">
                <img class="avatar" :src="user.avatar" alt="头像" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="!(user && user.org_id)"
                  command="OrgSettled"
                  >机构入驻</el-dropdown-item
                >
                <el-dropdown-item v-else command="admin"
                  >管理后台</el-dropdown-item
                >
                <el-dropdown-item command="LearningCenter"
                  >学习中心</el-dropdown-item
                >
                <el-dropdown-item command="CommentList"
                  >课程评价</el-dropdown-item
                >
                <el-dropdown-item command="UserInfo">个人信息</el-dropdown-item>
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div v-else class="not-login">
              <button @click="login" class="login">登录</button>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 抽屉 -->
      <el-drawer
        :with-header="false"
        :visible.sync="drawer"
        direction="ltr"
        append-to-body
        custom-class="navbar-drawer"
      >
        <div class="drawer-top">
          <img class="logo brand-logo" :src="brandLogo" alt="logo" />
          <img
            class="close"
            src="@/assets/img/close@2x.png"
            alt="关闭"
            @click="drawer = false"
          />
        </div>
        <ul class="drawer-nav">
          <router-link
            exact
            tag="li"
            :to="item.path"
            :class="$route.name === item.name ? 'activity' : ''"
            v-for="item in navList"
            :key="item.name"
            @click.native="drawer = false"
          >
            {{ item.title }}
          </router-link>
        </ul>
      </el-drawer>
    </div>
    <!-- 占位元素 -->
    <div class="seize-seat-ele"></div>
  </div>
</template>

<script>
import { EventBus } from "@saas/components/src/utils/event-bus";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { isH5, isMobile } from "@saas/components/src";
import SearchInput from "./search-input/Index.vue";
import { getCalendarCourseList } from "@saas/service-api/src/learning-center";
import { themeMixin } from "@saas/components/src/composables/useTheme";
const logoLight = require("../../assets/images/logo.png");
const logoDark = require("../../assets/images/logo-white.png");

export default {
  name: "NavBar",
  mixins: [themeMixin],
  data() {
    return {
      keyword: "",
      adminUrl: process.env.VUE_APP_ADMIN_URL,
      isH5: isH5(),
      isMobile: isMobile(),
      drawer: false,
      navList: [
        { title: "首页", name: "Home", path: "/" },
        { title: "关于我们", name: "About", path: "/about" },
        { title: "联系我们", name: "Contact", path: "/contact" },
        { title: "下载", name: "Download", path: "/download" },
      ],
      todayHaveLive: false,
      isScrolled: false,
    };
  },
  components: {
    SearchInput,
  },
  methods: {
    ...mapActions(["getProfile"]),
    handleMenuBehavior(command) {
      switch (command) {
        case "OrgSettled":
          this.$router.push({ name: "OrgSettled" });
          break;
        case "admin":
          window.open(this.adminUrl);
          break;
        case "LearningCenter":
          this.$router.push({ name: command });
          break;
        case "MyNote":
          this.$router.push({ name: command });
          break;
        case "UserInfo":
          this.$router.push({ name: command });
          break;
        case "CommentList":
          this.$router.push({ name: command });
          break;
        case "Exchange":
          let routeData = this.$router.resolve({ name: command });
          window.open(routeData.href);
          break;
        case "Trade":
          this.$router.push({ name: command });
          break;
        case "logout":
          this.logout();
          break;
      }
    },
    logout() {
      this.$chiralConfirmLoading(`是否确认退出账号`, "确定", (val) => {
        if (val) {
          this.$store.dispatch("clearProfile");
        }
      });
    },
    login() {
      this.$loginDialog();
    },
    judgeTodayHaveLive() {
      let params = {
        begin_at: Math.floor(new Date().setHours(0, 0, 0) / 1000),
        end_at: Math.floor((new Date().setHours(24, 0, 0, 0) - 1000) / 1000),
        page_no: 1,
        page_size: 1,
        is_calendar: 0,
      };
      getCalendarCourseList(params).then((res) => {
        if (res.code === 1) {
          let data = res.data?.list || [];
          if (data.length > 0) {
            this.todayHaveLive = true;
          }
        }
      });
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 10;
    },
  },
  mounted() {
    this.getProfile();
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    ...mapGetters(["isAuthenticated", "user"]),
    brandLogo() {
      return this.isDark ? logoDark : logoLight;
    },
  },
  watch: {
    isAuthenticated(val) {
      if (val) {
        this.judgeTodayHaveLive();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
//占位元素
.seize-seat-ele {
  height: 96px;
}
@media (max-width: 767px) {
  .seize-seat-ele {
    height: 1.6rem;
  }
}
.nav-bar {
  position: fixed;
  width: 100%;
  top: 0;
  font-size: 14px;
  color: var(--nav-pill-text);
  line-height: 22px;
  z-index: 1001;
  transition: all 0.3s ease;
  padding: 16px 0;

  &.nav-bar--transparent {
    background: transparent;
  }

  html.dark &.nav-bar--transparent {
    background: var(--nav-scrolled-bg);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    box-shadow: var(--shadow-soft);
  }

  &.nav-bar--scrolled {
    background: var(--nav-scrolled-bg);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    box-shadow: var(--shadow-soft);
    padding: 8px 0;
  }

  .learning-center-badge {
    position: absolute;
    top: -6px;
    right: -24px;
    display: flex;
    align-items: center;
    gap: 4px;
    background-color: #ecfdf5;
    border: 1px solid #d1fae5;
    color: #059669;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 9999px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease;
    z-index: 10;
    line-height: 1;

    .badge-dot-wrapper {
      position: relative;
      display: flex;
      height: 6px;
      width: 6px;
    }

    .badge-dot-ping {
      position: absolute;
      display: inline-flex;
      height: 100%;
      width: 100%;
      border-radius: 50%;
      background-color: #34d399;
      opacity: 0.75;
      animation: badgePing 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
    }

    .badge-dot-core {
      position: relative;
      display: inline-flex;
      border-radius: 50%;
      height: 6px;
      width: 6px;
      background-color: #059669;
    }
  }

  .nav-pill:hover .learning-center-badge {
    transform: translateY(-2px);
  }

  .menu-row {
    max-width: 1520px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    padding: 0 32px;

    .menu-left {
      display: flex;
      align-items: center;
      gap: 24px;

      .logo {
        display: flex;
        align-items: center;
        padding: 0;
        flex-shrink: 0;
        img {
          width: 140px;
        }
      }

      .nav-pills {
        display: flex;
        align-items: center;
        gap: 4px;
        background: var(--nav-pill-bg);
        padding: 4px;
        border-radius: 9999px;
        padding-left: 12px;
        padding-right: 12px;
      }

      .nav-pill {
        font-weight: 500;
        font-size: 14px;
        padding: 6px 16px;
        border-radius: 9999px;
        transition: all 0.2s ease;
        color: var(--nav-pill-text);
        white-space: nowrap;
        text-decoration: none;
        display: flex;
        align-items: center;
        gap: 4px;
        position: relative;

        &:hover {
          color: var(--nav-pill-active-text);
          background: var(--nav-pill-active-bg);
        }

        &.nav-pill--active,
        &.router-link-exact-active {
          color: var(--nav-pill-active-text);
          background: var(--nav-pill-active-bg);
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
          font-weight: 600;
        }
      }

      .nav-pill--highlight {
        font-weight: 700;
        position: relative;
        padding: 8px 16px;

        .nav-pill__store-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 3px;
          border-radius: 9999px;
          background: #d1fae5;
          color: #059669;
          transition: all 0.2s;
        }

        html.dark & .nav-pill__store-icon {
          background: rgba(6, 78, 59, 0.3);
          color: #34d399;
        }

        &:hover .nav-pill__store-icon {
          background: #10b981;
          color: #fff;
        }

        .nav-pill__badge {
          position: absolute;
          top: -2px;
          right: -6px;
          background: #f43f5e;
          color: #fff;
          font-size: 10px;
          font-weight: 700;
          padding: 1px 5px;
          border-radius: 9999px;
          border: 2px solid var(--card-bg);
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          line-height: 1.2;
          animation: pulse 2s infinite;
        }
      }
    }

    .menu-right {
      display: flex;
      align-items: center;
      gap: 12px;

      .msg-bell-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: none;
        border: none;
        cursor: pointer;
        color: var(--nav-pill-text);
        transition: all 0.2s;

        &:hover {
          color: var(--text-primary);
          background: var(--nav-pill-active-bg);
        }
      }

      .theme-toggle-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: none;
        border: none;
        cursor: pointer;
        color: var(--nav-pill-text);
        transition: all 0.2s;

        &:hover {
          color: var(--text-primary);
          background: var(--nav-pill-active-bg);
        }
      }

      .user-content {
        .user-avatar-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 3px 12px 3px 3px;
          background: var(--user-btn-bg);
          border: 1px solid var(--user-btn-border);
          border-radius: 9999px;
          cursor: pointer;
          transition: box-shadow 0.2s;

          &:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          }
        }
        .avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          border: 1px solid var(--avatar-border);
          object-fit: cover;
        }
        .user-name {
          font-size: 13px;
          font-weight: 600;
          color: var(--text-primary);
          max-width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .not-login {
        display: flex;
        align-items: center;
        gap: 12px;

        .login-btn {
          font-size: 14px;
          font-weight: 700;
          color: var(--nav-pill-text);
          padding: 6px 4px;
          background: none;
          border: none;
          cursor: pointer;
          transition: color 0.2s;

          &:hover {
            color: var(--nav-pill-active-text);
          }
        }

        .register-btn {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 14px;
          font-weight: 700;
          color: #fff;
          padding: 10px 20px;
          border-radius: 9999px;
          background: var(--register-btn-bg);
          border: none;
          cursor: pointer;
          transition: all 0.2s;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

          &:hover {
            background: #059669;
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
            transform: translateY(-1px);
          }

          .register-sparkle {
            color: #fb923c;
          }
        }
      }
    }
  }

  .brand-logo {
    filter: none;
  }

  // h5
  .h5-nav {
    height: 1.6rem;
    padding: 0 0.27rem 0;
    background: var(--card-bg);
    box-shadow: inset 0 -1px var(--border-subtle);
    display: flex;
    align-items: center;
    .logo-name {
      font-size: 0.43rem;
      display: flex;
      align-items: center;
      img {
        width: 2.4rem;
        margin-left: 0.27rem;
      }
    }
    .menu-right {
      justify-content: flex-end;
      align-items: center;
      display: flex;
      a {
        margin-right: 0.27rem;
        color: var(--text-primary);
      }
      .login {
        padding: 0.16rem 0.48rem;
        border-radius: 0.48rem;
        border: 1px solid $saas-theme-color;
        color: $saas-theme-color;
        background: var(--card-bg);
        font-size: 0.37rem;
        font-weight: 400;
      }
      .avatar {
        width: 0.85rem;
        height: 0.85rem;
        border-radius: 50%;
      }
    }
  }
}
// 抽屉
:deep .navbar-drawer.el-drawer {
  width: 6.4rem !important;
}
.navbar-drawer {
  .drawer-top {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1.6533rem;
    margin-bottom: 0.6667rem;
    position: relative;
    .logo {
      width: 2.67rem;
    }
    .close {
      width: 0.32rem;
      height: 0.32rem;
      position: absolute;
      right: 0.32rem;
    }
  }
  .drawer-nav {
    font-size: 0.4267rem;
    li {
      padding: 0.4rem 1.0667rem;
      text-align: center;
      font-size: 0.4rem;
      font-weight: 500;
      color: $chiral-color;
      line-height: 0.56rem;
    }
    .activity {
      background: #f9f9fb;
    }
  }
}

// 适配
@media (max-width: 1520px) {
  .nav-bar {
    .menu-row {
      width: 100%;
      padding: 0 24px;
    }
  }
}
@media (max-width: 992px) {
  .nav-bar {
    .menu-row {
      font-size: 13px;
      padding: 0 16px;
    }
  }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

@keyframes badgePing {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
</style>
